export default __webpack_public_path__ + "CargarPostulantesdeAnglo_desarrollo.xlsx";